module.exports = __webpack_public_path__ + "img/notOverview.fb6056dd.png";